// Pure first-run routing — extracted so the gate decision is unit-testable without
// rendering (the SPA has no testing-library; this mirrors the wizard-step.ts pattern).
//
// `firstRunCompleted` is the SINGLE hard gate: the dedicated first-run flag written at the
// wizard's (or checklist's) final step — NOT the read-latched `onboarded_at`, which latches
// on every readiness GET and would hide onboarding from a user who connected a source then
// bailed mid-flow (design §10.3 / D11). When it is false we split:
//   - cold  = no progress of any kind                 → guided wizard
//   - else  = came back half-set-up (some progress)   → free-form return checklist

export type OnboardingView = 'dashboard' | 'wizard' | 'checklist';

export interface OnboardingRouting {
  firstRunCompleted: boolean;
  connectedSourceCount: number;
  hasApiKey: boolean;
  extensionConnected: boolean;
}

export function chooseOnboardingView(data: OnboardingRouting): OnboardingView {
  if (data.firstRunCompleted) return 'dashboard';
  const cold = data.connectedSourceCount === 0 && !data.hasApiKey && !data.extensionConnected;
  return cold ? 'wizard' : 'checklist';
}
